Ext.define('SA.view.SessionDirtyPopup', {
    alias: 'widget.session-dirty-popup',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-session-dirty-popup',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'component',
            cls: 'sa-session-dirty-popup-body',
            itemId: 'body',

            html: [
                '<svg class="sa-session-dirty-popup-info-svg"><use href="#sa-icon-map-info"></use></svg>',
                '<div>',
                    'There has been a change to your account that requires us to reload SimplyAnalytics.',
                '</div>'
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-session-dirty-popup-footer',

            items: [
                {
                    xtype: 'sa-button',
                    cls: 'sa-session-dirty-popup-reload-button',
                    itemId: 'reloadBtn',
                    text: 'Reload',
                    ui: 'primary'
                }
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.reloadBtn = this.down('#reloadBtn');
        this.reloadBtn.on('click', this.onReloadBtnClick, this);
    },

    onReloadBtnClick() {
        this.reloadBtn.disable();
        this.reloadBtn.setText('Reloading…');

        this.handler();
    }
});